export default function initLogoAnimation() {
  window.addEventListener('beforeunload', () => {
    $('.tanuki-logo').addClass('animate');
  });
}



// WEBPACK FOOTER //
// ./logo.js